import React from "react";
import OptionCard from "./OptionCard";

const ImageChatView = ({ series }: { series: any }) => (
  <div className="space-y-4">
    <img
      src={series.question.imageUrl}
      alt="Chat image"
      className="w-full rounded"
    />
    <div className="flex gap-3 overflow-x-auto pb-2">
      {series.options.map((opt: any) => (
        <OptionCard
          key={opt.id}
          option={opt}
          isCorrect={series.answer.includes(opt.id)}
        />
      ))}
    </div>
  </div>
);

export default ImageChatView;
